export default "__VITE_ASSET__CbrX7Oux__"